const firmwareManagementsConfig = {
  // msp > org get firmware ( Issue 85 )
  "/ents/:entId/orgs/:orgId/firmware/setting.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/firmware/setting",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "firmwareManagements.mainFWList",
  },
  // msp > org > site get firmware ( Issue 85 )
  "/ents/:entId/orgs/:orgId/sites/:siteId/firmware/setting.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/firmware/setting",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "firmwareManagements.mainFWList",
  },
  // org get firmware ( Issue 85 )
  "/orgs/:orgId/firmware/setting.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/firmware/setting",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "firmwareManagements.mainFWList",
  },
  // org > site > get firmware ( Issue 85 )
  "/orgs/:orgId/sites/:siteId/firmware/setting.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/firmware/setting",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "firmwareManagements.mainFWList",
  },
  // msp > org update firmware ( Issue 85 )
  "/ents/:entId/orgs/:orgId/firmware/setting.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/firmware/setting",
    restful: true,
    method: "update",
    buildParams: params => params,
    action: null,
    mockSelector: "firmwareManagements.mainFWList",
  },
  // msp > org > site update firmware ( Issue 85 )
  "/ents/:entId/orgs/:orgId/sites/:siteId/firmware/setting.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/firmware/setting",
    restful: true,
    method: "update",
    buildParams: params => params,
    action: null,
    mockSelector: "firmwareManagements.mainFWList",
  },
  // org update firmware ( Issue 85 )
  "/orgs/:orgId/firmware/setting.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/firmware/setting",
    restful: true,
    method: "update",
    buildParams: params => params,
    action: null,
    mockSelector: "firmwareManagements.mainFWList",
  },
  // org > site > update firmware ( Issue 85 )
  "/orgs/:orgId/sites/:siteId/firmware/setting.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/firmware/setting",
    restful: true,
    method: "update",
    buildParams: params => params ,
    action: null,
    mockSelector: "firmwareManagements.mainFWList",
  },
  // msp > org > get release note ( Issue 85 )
  "/ents/:entId/orgs/:orgId/firmware/releaseNote.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/firmware/releaseNote",
    restful: true,
    method: "read",
    buildParams: (params) => ({ ...params }),
    action: null,
    mockSelector: "firmwareManagements.releaseNote",
  },
  // msp > org > site > get release note ( Issue 85 )
  "/ents/:entId/orgs/:orgId/sites/:siteId/firmware/releaseNote.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/firmware/releaseNote",
    restful: true,
    method: "read",
    buildParams: params => ({ ...params }),
    action: null,
    mockSelector: "firmwareManagements.releaseNote",
  },
  // org > get release note ( Issue 85 )
  "/orgs/:orgId/firmware/releaseNote.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/firmware/releaseNote",
    restful: true,
    method: "read",
    buildParams: params => ({ ...params }),
    action: null,
    mockSelector: "firmwareManagements.releaseNote",
  },
  // org > site > get release note ( Issue 85 )
  "/orgs/:orgId/sites/:siteId/firmware/releaseNote.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/firmware/releaseNote",
    restful: true,
    method: "read",
    buildParams: params => ({ ...params }),
    action: null,
    mockSelector: "firmwareManagements.releaseNote",
  },
  // msp > org > get support list ( Issue 85 )
  "/ents/:entId/orgs/:orgId/firmware/supportList.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/firmware/supportList",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "firmwareManagements.supportList",
  },
  // org > get support list ( Issue 85 )
  "/orgs/:orgId/firmware/supportList.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/firmware/supportList",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "firmwareManagements.supportList",
  },
};

export default firmwareManagementsConfig;
